import base58 from "../utils/base58";
import cryptoUtils from '../utils/utils';

function getDecoded(address) {
    try {
        return base58.decode(address);
    } catch (e) {
        // if decoding fails, assume invalid address
        return null;
    }
}

function getChecksum(hashFunction, payload) {
    return cryptoUtils.sha256Checksum(payload);
}

export default {
    isValidAddress(address, currency, opts = {}) {
        // Check if address is a string
        if (typeof address !== 'string') {
            return false;
        }

        // Check if address is exactly 50 characters long
        if (address.length !== 50) {
            return false;
        }

        // Check if the address starts with '3' or '4' (common for Concordium)
        if (!address.startsWith('3') && !address.startsWith('4')) {
            return false;
        }

        const expectedLength = 37;
        const hashFunction = "sha256";
        const decoded = getDecoded(address);

        if (decoded) {
            const { length } = decoded;

            if (length !== expectedLength) {
                return false;
            }

            // Verify the version byte (should be 1 for Concordium)
            if (decoded[0] !== 1) {
                return false;
            }

            const checksum = cryptoUtils.toHex(decoded.slice(length - 4, length));

            const body = cryptoUtils.toHex(decoded.slice(0, length - 4));

            const goodChecksum = getChecksum(hashFunction, body);

            return checksum === goodChecksum;
        }

        return false;
    }
};
